export default {
  map: 'Carte',
  moreDetails: 'Plus de détails',
  maxPassenger: 'Maximum de passagers: {{number}}',
  btnBook: 'Réserver le trajet', 
};